import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-06/task-01";

const task: Slide = {
  titleHtml:
    "A plane wave propagate in medium 1 and and encounter a medium 2. Given the<br>incident pressure at time t = 0 s, compose the total field pressure after reflection and<br>transmission at time t = 4L/c<sub>1</sub>. The density of medium 2 is four times that of medium 1,<br>while the acoustic velocity in medium 2 is half that in medium 1.",
  description: "Connect correct profiles with their correct positions.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 1,
      components: [
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
